function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import Icon from '../icon';
var prefixCls = 'eui';
var DEFAULT_PLACEHOLDER_STRING = '请选择';

var Select = /*#__PURE__*/function (_React$Component) {
  _inherits(Select, _React$Component);

  var _super = _createSuper(Select);

  function Select(props) {
    var _this;

    _classCallCheck(this, Select);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleMouseDown", function (event) {
      var _this$props = _this.props,
          onFocus = _this$props.onFocus,
          disabled = _this$props.disabled;
      var isOpen = _this.state.isOpen;

      if (onFocus && typeof onFocus === 'function') {
        onFocus(isOpen);
      }

      if (event.type === 'mousedown' && event.button !== 0) return;
      event.stopPropagation();
      event.preventDefault();

      if (!disabled) {
        _this.setState({
          isOpen: !isOpen
        }, function () {
          if (!isOpen && _this.selected) {
            _this.ul.scrollTop = _this.selected.offsetTop;
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleDocumentClick", function (event) {
      if (_this.mounted) {
        if (!ReactDOM.findDOMNode(_assertThisInitialized(_this)).contains(event.target)) {
          if (_this.state.isOpen) {
            _this.setState({
              isOpen: false
            });
          }
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "fireChangeEvent", function (newState) {
      var selected = _this.state.selected;
      var onChange = _this.props.onChange;

      if (newState.selected !== selected && onChange) {
        onChange(newState.selected);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setValue", function (value, label) {
      var newState = {
        selected: {
          value: value,
          label: label
        },
        isOpen: false
      };

      _this.fireChangeEvent(newState);

      _this.setState(newState);
    });

    _defineProperty(_assertThisInitialized(_this), "isValueSelected", function () {
      return typeof _this.state.selected === 'string' || _this.state.selected.value !== '';
    });

    _this.state = {
      selected: _this.parseValue(props.value, props.options) || {
        label: typeof props.placeholder === 'undefined' ? DEFAULT_PLACEHOLDER_STRING : props.placeholder,
        value: ''
      },
      isOpen: false
    };
    _this.mounted = true;
    _this.handleDocumentClick = _this.handleDocumentClick.bind(_assertThisInitialized(_this));
    _this.fireChangeEvent = _this.fireChangeEvent.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('click', this.handleDocumentClick, false);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this$props2 = this.props,
          options = _this$props2.options,
          value = _this$props2.value;

      if (nextProps.options !== options || nextProps.value !== value) {
        if (nextProps.value === null || nextProps.value === undefined) {
          this.setState({
            selected: {
              label: typeof nextProps.placeholder === 'undefined' ? DEFAULT_PLACEHOLDER_STRING : nextProps.placeholder,
              value: ''
            }
          });
        } else {
          var selected = this.parseValue(nextProps.value, nextProps.options);

          if (selected && selected !== this.state.selected) {
            this.setState({
              selected: selected
            });
          }
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
      document.removeEventListener('click', this.handleDocumentClick, false);
    }
  }, {
    key: "parseValue",
    value: function parseValue(value, options) {
      var option;

      if (typeof value === 'string') {
        for (var i = 0, num = options.length; i < num; i++) {
          if (options[i].type === 'group') {
            var match = options[i].items.filter(function (item) {
              return item.value === value;
            });

            if (match.length) {
              option = match[0];
            }
          } else if (typeof options[i].value !== 'undefined' && options[i].value === value) {
            option = options[i];
          }
        }
      }

      return option || value;
    }
  }, {
    key: "buildMenu",
    value: function buildMenu() {
      var _this2 = this;

      var options = this.props.options;
      var ops = options.map(function (option) {
        return _this2.renderOption(option);
      });
      return ops.length ? ops : /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-select-noresult")
      }, "No options found");
    }
  }, {
    key: "renderOption",
    value: function renderOption(option) {
      var _classes,
          _this3 = this;

      var selected = this.state.selected;
      var value = option.value;

      if (typeof value === 'undefined') {
        value = option.label || option;
      }

      var label = option.label || option.value || option;
      var classes = (_classes = {}, _defineProperty(_classes, "".concat(prefixCls, "-dropdown-item"), true), _defineProperty(_classes, option.className, !!option.className), _defineProperty(_classes, "selected", value === selected.value || value === selected), _classes);
      var optionClass = classNames(classes);
      return /*#__PURE__*/React.createElement("li", {
        key: option.key,
        className: optionClass,
        onMouseDown: this.setValue.bind(this, value, label),
        onClick: this.setValue.bind(this, value, label),
        ref: function ref(el) {
          return classes.selected && (_this3.selected = el);
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-dropdown-item-text")
      }, label), /*#__PURE__*/React.createElement(Icon, {
        value: "check",
        className: "".concat(prefixCls, "-dropdown-item-icon")
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames,
          _classNames2,
          _classNames3,
          _classNames4,
          _classNames5,
          _this4 = this;

      var _this$props3 = this.props,
          disabled = _this$props3.disabled,
          controlClassName = _this$props3.controlClassName,
          placeholderClassName = _this$props3.placeholderClassName,
          menuClassName = _this$props3.menuClassName,
          arrowClassName = _this$props3.arrowClassName,
          className = _this$props3.className,
          other = _objectWithoutProperties(_this$props3, ["disabled", "controlClassName", "placeholderClassName", "menuClassName", "arrowClassName", "className"]);

      var _this$state = this.state,
          selected = _this$state.selected,
          isOpen = _this$state.isOpen;
      var disabledClass = disabled ? 'disabled' : '';
      var placeHolderValue = typeof selected === 'string' ? selected : selected.label;
      var dropdownClass = classNames((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-select"), true), _defineProperty(_classNames, className, !!className), _defineProperty(_classNames, "expand", isOpen), _defineProperty(_classNames, disabledClass, !!disabledClass), _classNames));
      var controlClass = classNames((_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-select-input"), true), _defineProperty(_classNames2, controlClassName, !!controlClassName), _classNames2));
      var placeholderClass = classNames((_classNames3 = {}, _defineProperty(_classNames3, "".concat(prefixCls, "-select-placeholder"), true), _defineProperty(_classNames3, placeholderClassName, !!placeholderClassName), _defineProperty(_classNames3, "selected", this.isValueSelected()), _classNames3));
      var menuClass = classNames((_classNames4 = {}, _defineProperty(_classNames4, "".concat(prefixCls, "-dropdown-list"), true), _defineProperty(_classNames4, menuClassName, !!menuClassName), _classNames4));
      var arrowClass = classNames((_classNames5 = {}, _defineProperty(_classNames5, "".concat(prefixCls, "-select-input-icon"), true), _defineProperty(_classNames5, arrowClassName, !!arrowClassName), _classNames5));
      var value = /*#__PURE__*/React.createElement("div", {
        className: placeholderClass
      }, placeHolderValue);
      var menu = isOpen ? /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-dropdown")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-dropdown-bd")
      }, /*#__PURE__*/React.createElement("ul", {
        className: menuClass,
        ref: function ref(el) {
          return _this4.ul = el;
        }
      }, this.buildMenu()))) : null;
      return /*#__PURE__*/React.createElement("div", _extends({
        className: dropdownClass
      }, other), /*#__PURE__*/React.createElement("div", {
        className: controlClass,
        onMouseDown: this.handleMouseDown
      }, value, /*#__PURE__*/React.createElement(Icon, {
        value: "arrow",
        className: arrowClass
      })), menu);
    }
  }]);

  return Select;
}(React.Component);

_defineProperty(Select, "defaultProps", {
  options: [],
  value: undefined,
  placeholder: undefined
});

_defineProperty(Select, "propTypes", {
  options: PropTypes.array,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  placeholder: PropTypes.string
});

export default Select;